// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ScrollAnimateController from "./scroll_animate_controller"
application.register("scroll-animate", ScrollAnimateController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import FlipCardController from "./flip_card_controller"
application.register("flip-card", FlipCardController)

import AgentBuilderController from "./agent_builder_controller"
application.register("agent-builder", AgentBuilderController)

import SessionReplayController from "./session_replay_controller"
application.register("session-replay", SessionReplayController)

import GitHubStarsController from "./github_stars_controller"
application.register("github-stars", GitHubStarsController)

import EmailVerificationController from "./email_verification_controller"
application.register("email-verification", EmailVerificationController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import SignupController from "./signup_controller"
application.register("signup", SignupController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)
